module.exports = __webpack_public_path__ + "img/site.fdc9076.svg";